import React from 'react';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';
import { Text } from '../../../../CommonComponents/OPL/Text/Text';
import { IconButton } from '../../../../CommonComponents/OPL/IconButton/IconButton';

interface Props {
  onEdit(): void;
}

export const EditableField: React.FC<Props> = ({ children, onEdit }) => {
  return (
    <Box display="flex" px="12" py="24">
      <Box flex={1} display="flex" alignItems="center">
        <Text fontWeight={500}>{children}</Text>
      </Box>

      <IconButton
        icon="far fa-pencil"
        variant="subtleInactive"
        aria-label="Edit field"
        onClick={onEdit}
      />
    </Box>
  );
};
